import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/home/game_arrow_white.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "top_card" }
const _hoisted_4 = { class: "card_text" }
const _hoisted_5 = { class: "card_text" }
const _hoisted_6 = { class: "card_text" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "no_more"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "sub_text" }

import {ref } from 'vue';
import LogCard from './components/logCard.vue';
import { formatCurrency } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import NoData from '../components/common/noData.vue';
import { GameLogData } from '@/view/gameLog/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'gameLogView',
  props: {
    dataSet: {}
  },
  emits: ['onClickTab', 'getNextPageMsgList'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const active = ref(props.dataSet.active);

const emits = __emit

const onClickTab = (active: any) => {
    emits('onClickTab', active)
}
const getNextPageMsgList = () => {
    emits('getNextPageMsgList')
}



return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('gameLog.gameRegistration')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_tabs, {
        active: active.value,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
        sticky: "",
        ellipsis: false,
        onClickTab: onClickTab
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.tabList, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_tab, {
              key: index,
              title: `${item.timeName} ${_ctx.$t(item.name)}`,
              name: index
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('gameLog.latestData')) + " " + _toDisplayString(item.timeName + ' ' + _ctx.$t(item.name)), 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.bets')) + " " + _toDisplayString(_ctx.dataSet.total) + " " + _toDisplayString(_ctx.$t('common.times')) + ": ", 1),
                      _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(_ctx.dataSet.betTotal)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createTextVNode(_toDisplayString(_ctx.$t('gameLog.winOrLoss')) + "： ", 1),
                      _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(_ctx.dataSet.winLossAmount)), 1)
                    ])
                  ]),
                  (_ctx.dataSet.betList.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.betList, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createVNode(LogCard, {
                              "bet-amount": item.betAmount,
                              returnAmount: item.winAmount,
                              profit: item.income,
                              time: item.createTime,
                              sessionId: item.orderNo,
                              gameName: item.gameName
                            }, null, 8, ["bet-amount", "returnAmount", "profit", "time", "sessionId", "gameName"])
                          ]))
                        }), 128)),
                        (_ctx.dataSet.total > _ctx.dataSet.pageSize * _ctx.dataSet.pageNum)
                          ? (_openBlock(), _createBlock(_component_van_row, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_van_col, {
                                  span: "24",
                                  class: "arrowDown"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: _imports_0,
                                      alt: "",
                                      onClick: getNextPageMsgList
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('message.noMore')), 1))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(NoData),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('gameLog.subText')), 1)
                      ]))
                ])
              ]),
              _: 2
            }, 1032, ["title", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["active"])
    ])
  ], 64))
}
}

})